import Vue from "vue";
import initialData from "~/mixins/initial-state";

Vue.mixin(initialData);
